import { render, staticRenderFns } from "./PantauAS.vue?vue&type=template&id=4f98783c"
import script from "./PantauAS.vue?vue&type=script&lang=js"
export * from "./PantauAS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports